// extracted by mini-css-extract-plugin
module.exports = {"base":"Text__base__hhfNO","textInput":"Text__textInput__2JK-4","isCursorText":"Text__isCursorText__zto4K"};